import React from 'react';
import {useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";

import {PageSection, ReferanceCard} from "../../../components";
import {desktopEdHubReferences, mobileEdHubReferences} from "../../../../../assets/data/educationHub/referancesData";
import TransMsg from "../../transMessage";
import {ResourceList} from "../resourceList/ResourceList";
import FilePdfIcon from "../../../../../assets/images/svgs/file-pdf.svg";
import {additionalResources, cardItemList, styles} from "./forPatientsAndCaregivers-helpers";
import {theme} from "../../../../../utils";
import {ResourceCards} from "./ResourceCards";

export const ForPatientsAndCaregivers = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <>
            {/* FeaturedContent with Resource Cards */}
            <PageSection
                title={t(TransMsg.FEATURED_CONTENT)}
                description={t(TransMsg.FEATURED_CONTENT_DESCRIPTION)}
                descriptionSx={styles.featuredContent.descriptionSx}
                containerBoxSx={styles.featuredContent.containerBoxSx}
                subTitleSx={styles.featuredContent.subTitleSx}
                customElement={<ResourceCards cards={cardItemList} />}
            />

            {/* Additional Resources */}
            <PageSection
                title={t(TransMsg.ADDITIONAL_CONTENT)}
                description={t(TransMsg.ADDITIONAL_CONTENT_DESCRIPTION)}
                sectionWrapperSx={{ backgroundColor: "#F8F8F8", pb: "150px" }}
                descriptionSx={{ mt: "18px", fontSize: "16.17px", color: "#393939", maxWidth:"768px", lineHeight: "27px", fontWeight:"300" }}
                subTitleSx={{ mt: "38px", color: "#A62C4E" }}
                customElement={<ResourceList listItems={additionalResources} buttonText={"Open PDF"} buttonIcon={FilePdfIcon} />}
            />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
            />
        </>
    )
};
